export default __webpack_public_path__ + "static/media/stir-pot.ca24e5d6.gif";